import React from 'react';
import { getIn } from 'formik';
import cn from 'classnames';

import Input from 'Components/Input';
import formatToDecimal from '../../../../screens/shared/util/formatToDecimal';

const units = [
  {
    id: 1,
    label: 'Hour(s)',
    value: 'HOUR',
  },
  {
    id: 2,
    label: 'Day(s)',
    value: 'DAY',
  },
  {
    id: 3,
    label: 'Week(s)',
    value: 'WEEK',
  },
  {
    id: 4,
    label: 'Month(s)',
    value: 'MONTH',
  },
];

const EditBlockQuotation = ({ servicesOptions, service, index, handleChange, errors, arrayHelpers, setFieldValue }) => {
  return (
    <>
      <div
        className={cn('modal__edit-block', { 'modal__edit-block--error': errors.services && errors.services[index] })}
        data-testid="modal-edit-block"
      >
        <div className="modal__edit-block--row">
          <Input
            className="modal__edit-block--middle-input"
            variant="select"
            helper={getIn(errors, `services[${index}].service`)}
            helperVariant={getIn(errors, `services[${index}].service`) && 'error'}
            callback={(e) => setFieldValue(`services[${index}].service`, e)}
            options={servicesOptions}
            fieldProps={{
              value: service.service,
              name: `services[${index}].service`,
              placeholder: 'Select service',
            }}
          />
          <Input
            className="modal__edit-block--small-input"
            variant="select"
            helper={getIn(errors, `services[${index}].unit`)}
            helperVariant={getIn(errors, `services[${index}].unit`) && 'error'}
            callback={(e) => setFieldValue(`services[${index}].unit`, e)}
            options={units}
            fieldProps={{
              value: service.unit,
              name: `services[${index}].unit`,
              placeholder: 'Select UNIT',
            }}
          />
          <Input
            className="modal__edit-block--small-input"
            inputMask=""
            maskChar=""
            helper={getIn(errors, `services[${index}].qty`)}
            helperVariant={getIn(errors, `services[${index}].qty`) && 'error'}
            fieldProps={{
              value: service.qty,
              name: `services[${index}].qty`,
              placeholder: 'Quantity',
              onChange: (e) => setFieldValue(`services[${index}].qty`, formatToDecimal(e.target.value)),
            }}
          />
          <Input
            className="modal__edit-block--small-input"
            inputMask=""
            maskChar=""
            helper={getIn(errors, `services[${index}].price`)}
            helperVariant={getIn(errors, `services[${index}].price`) && 'error'}
            fieldProps={{
              value: service.price,
              name: `services[${index}].price`,
              placeholder: '0 USD',
              onChange: (e) => setFieldValue(`services[${index}].price`, formatToDecimal(e.target.value)),
            }}
          />
          <Input
            className="modal__edit-block--small-input"
            disabled={true}
            fieldProps={{
              value: service.qty && service.price ? (+service.qty * +service.price).toFixed(2) : '',
              placeholder: '0 USD',
            }}
          />
        </div>
        <Input
          variant="textarea"
          className="modal__edit-block-description"
          callback={handleChange}
          fieldProps={{
            value: service.description,
            name: `services[${index}].description`,
            placeholder: 'Add your description',
          }}
        />
        <span className="icon-close" onClick={() => arrayHelpers.remove(index)} />
      </div>
    </>
  );
};

export default EditBlockQuotation;
